import { Route } from "@angular/router";
import { LoginComponent } from "./login.component";

export const LoginRouting: Route = { 
    path: 'login', component: LoginComponent 
};